module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="design-transform-section">\n    <div class="iframe-container">\n        <iframe src="' +
__e( psdImportBaseUrl ) +
'" name="psdImport"></iframe>\n    </div>\n<div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/psdImport/PSDImportView.tpl
// module id = 3117
// module chunks = 0